module.exports = __webpack_public_path__ + "img/up-from-line.08ba4015.svg";